import ComponentElement from 'components/component-element';
import {createElement, getTransitionDuration} from 'methods/utils';

function calcTotalTransform($el) {
    const transform = {
        a: 0,
        b: 0,
        c: 0,
        d: 0,
        tx: 0,
        ty: 0,
    }

    while ($el) {
        const targetStyle = window.getComputedStyle($el);

        if (/^matrix3d/.test(targetStyle.transform)) {
            const params = targetStyle.transform.match(/\((.*)\)/)[1].split(', ');
            transform.a += parseFloat(params[0]);
            transform.b += parseFloat(params[1]);
            transform.c += parseFloat(params[4]);
            transform.d += parseFloat(params[5]);
            transform.tx += parseFloat(params[12]);
            transform.ty += parseFloat(params[13]);
        } else if (/^matrix/.test(targetStyle.transform)) {
            const params = targetStyle.transform.match(/\((.*)\)/)[1].split(', ');
            transform.a += parseFloat(params[0]);
            transform.b += parseFloat(params[1]);
            transform.c += parseFloat(params[2]);
            transform.d += parseFloat(params[3]);
            transform.tx += parseFloat(params[4]);
            transform.ty += parseFloat(params[5]);
        }

        $el = $el.offsetParent;
    }

    return transform;
}

function Hint($target, options = {}) {
    this.$target = $target;

    options.withClose = !!options.withClose;

    let $element;
    if (options.withClose) {
        $element = createElement(
            `<div class="Hint">
                <div class="Hint-tooltip">
                    <div class="Hint-header">
                        <div class="Hint-close js-close">
                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path fill-rule="evenodd" clip-rule="evenodd" d="M12 22.0001C17.5228 22.0001 22 17.523 22 12.0001C22 6.47727 17.5228 2.00012 12 2.00012C6.47715 2.00012 2 6.47727 2 12.0001C2 17.523 6.47715 22.0001 12 22.0001ZM16.307 7.69302C16.6976 8.08354 16.6976 8.7167 16.307 9.10723L13.4142 12.0001L16.307 14.893C16.6976 15.2835 16.6976 15.9167 16.307 16.3072C15.9165 16.6978 15.2834 16.6978 14.8928 16.3072L11.9999 13.4143L9.10705 16.3072C8.71653 16.6978 8.08336 16.6978 7.69284 16.3072C7.30231 15.9167 7.30231 15.2835 7.69284 14.893L10.5857 12.0001L7.69284 9.10723C7.30231 8.7167 7.30231 8.08354 7.69284 7.69302C8.08336 7.30249 8.71653 7.30249 9.10705 7.69302L11.9999 10.5859L14.8928 7.69302C15.2834 7.30249 15.9165 7.30249 16.307 7.69302Z" fill="#D4D2D8"/>
                            </svg>
                        </div>
                    </div>
                    <div class="Hint-content"></div>
                </div>
            </div>`
        );
    } else {
        $element = createElement(
            `<div class="Hint">
                <div class="Hint-tooltip">
                    <div class="Hint-content"></div>
                </div>
            </div>`
        );
    }

    // наследование
    ComponentElement.call(this, $element, options);

    this._updatePositionBind = this.updatePosition.bind(this);
    this._parentsWithScrollEventAttached = [];

    // сохраняем Hint в элемент
    $target.hint = this;

    this.$tooltip     = this.$element.querySelector('.Hint-tooltip');
    this.$content     = this.$element.querySelector('.Hint-content');
    this.$closeButton = this.$element.querySelector('.js-close');

    this.$content[this.options.allowHTML ? 'innerHTML' : 'textContent'] = this.options.content;

    if (this.options.withClose) {
        this.addEventListener(this.$target, 'click', this._onTargetMouseClickEvent.bind(this));
        this.addEventListener(this.$closeButton, 'click', this._onElementCloseEvent.bind(this));
    } else {
        this.addEventListener(this.$target, 'mouseenter', this._onTargetMouseEnterEvent.bind(this));
        this.addEventListener(this.$target, 'mouseleave', this._onTargetMouseLeaveEvent.bind(this));
    }

    if (this.options.interactive && !this.options.withClose) {
        this.addEventListener(this.$element, 'mouseenter', this._onElementMouseEnterEvent.bind(this));
        this.addEventListener(this.$element, 'mouseleave', this._onElementMouseLeaveEvent.bind(this));
    }

    if (this.options.follow.cursor) {
        this.addEventListener(this.$target, 'mousemove', this._onTargetMouseMoveEvent.bind(this));
    }

    if (this.options.width) {
        this.$element.style.maxWidth = this.options.width;
        this.$tooltip.style.maxWidth = this.options.width;
    }

    if (this.options.height) {
        this.$element.style.maxHeight = this.options.height;
        this.$tooltip.style.maxHeight = this.options.height;
    }

    if (this.options.withClass) {
        this.$element.classList.add(this.options.withClass);
    }

    if (this.$target.dataset.placement) {
        this.options.placement = this.$target.dataset.placement;
    }

    this.$element.dataset.placement = this.options.placement;

    this.xMouseOffset = 0;
    this.YMouseOffset = 0;
}

// наследование
Hint.prototype = Object.create(ComponentElement.prototype);

// цепочка прототипов
Object.defineProperty(Hint.prototype, 'constructor', {
    value: Hint,
    writable: true,
    enumerable: false,
});

Hint.prototype.setOptions = function(options) {
    ComponentElement.prototype.setOptions.call(this, Object.assign({
        placement: 'top',
        cursor: false,
        follow: {
            cursor: false,
        },
        interactive: true,
        allowHTML: false,
        zIndex: 9999,
        xOffset: 0,
        yOffset: 0,
        canOpen: null,
    }, this.getElementDataset(this.$target).hint || {}, options));
}

Hint.prototype.setContent = function(content) {
    this.$content[this.options.allowHTML ? 'innerHTML' : 'textContent'] = content;
}

Hint.prototype.open = function() {
    if (this.$element.hasAttribute('disabled') || this.$element.classList.contains('is-active')) {
        return;
    }

    clearTimeout(this._closeTimeout);
    clearTimeout(this._leaveTimeout);

    Object.assign(this.$element.style, {
        position: 'absolute',
        pointerEvents: this.options.interactive || this.options.withClose ? '' : 'none',
        zIndex: this.options.zIndex,
        visibility: 'visible',
        margin: '0px',
    });

    document.body.appendChild(this.$element);
    this._hookAllParentScrolls();
    this.updatePosition();

    this.$element.classList.add('is-active');
}

Hint.prototype.close = function() {
    this.$element.classList.remove('is-active');

    this._unhookAllParentScrolls();

    this._closeTimeout = setTimeout(() => {
        if (this.$element.parentElement) {
            this.$element.parentElement.removeChild(this.$element);
        }
    }, getTransitionDuration(this.$tooltip));
}

Hint.prototype.updatePosition = function() {
    const targetRect = this.$target.getBoundingClientRect();
    const tooltipRect = this.$element.getBoundingClientRect();
    const windowWidth = window.innerWidth;
    const windowHeight = window.innerHeight;

    let xOffset = 0;
    let yOffset = 0;

    switch (this.options.placement) {
        case 'top':
            xOffset = targetRect.left + (targetRect.width / 2) - (tooltipRect.width / 2);
            yOffset = targetRect.top - tooltipRect.height;
            break;
        case 'right':
            xOffset = targetRect.right;
            yOffset = targetRect.top + (targetRect.height / 2) - (tooltipRect.height / 2);
            break;
        case 'bottom':
            xOffset = targetRect.left + (targetRect.width / 2) - (tooltipRect.width / 2);
            yOffset = targetRect.bottom;
            break;
        case 'left':
            xOffset = targetRect.left - tooltipRect.width;
            yOffset = targetRect.top + (targetRect.height / 2) - (tooltipRect.height / 2);
            break;
    }

    // Учитываем смещение курсора, если оно используется
    if (this.options.follow.cursor) {
        xOffset += this.xMouseOffset;
        yOffset += this.yMouseOffset;
    }

    // Учитываем пользовательское смещение
    xOffset += this.options.xOffset;
    yOffset += this.options.yOffset;

    // Корректировка, если подсказка выходит за пределы экрана
    if (xOffset < 0) {
        xOffset = 0;
    } else if (xOffset + tooltipRect.width > windowWidth) {
        xOffset = windowWidth - tooltipRect.width;
    }

    if (yOffset < 0) {
        yOffset = 0;
    } else if (yOffset + tooltipRect.height > windowHeight) {
        yOffset = windowHeight - tooltipRect.height;
    }

    // Позиционирование элемента
    this.$element.style.position = 'fixed';
    this.$element.style.left = `${xOffset}px`;
    this.$element.style.top = `${yOffset}px`;
}

Hint.prototype._onTargetMouseEnterEvent = function(e) {
    this.xMouseOffset = e.offsetX;
    this.yMouseOffset = e.offsetY;

    if (typeof this.options.canOpen == 'function' && this.options.canOpen(this) === false) {
        return;
    }

    this.open();
}

Hint.prototype._onTargetMouseClickEvent = function(e) {
    this.xMouseOffset = e.offsetX;
    this.yMouseOffset = e.offsetY;

    if (this.$element.classList.contains('is-active')) {
        this.close();
    } else {
        this.open();
    }
}

Hint.prototype._onElementCloseEvent = function(e) {
    this.xMouseOffset = e.offsetX;
    this.yMouseOffset = e.offsetY;

    this.close();
}

Hint.prototype._onTargetMouseMoveEvent = function(e) {
    this.xMouseOffset = e.offsetX;
    this.yMouseOffset = e.offsetY;
    this.updatePosition();
}

Hint.prototype._onTargetMouseLeaveEvent = function(e) {
    // таймаут позволяет выйти из общего потока и его можно отменить
    // 0 сек т.к. события mouseleave, mouseenter идут друг за другом
    clearTimeout(this._leaveTimeout);
    this._leaveTimeout = setTimeout(() => {
        this.close();
    }, 0);
}

Hint.prototype._onElementMouseEnterEvent = function(e) {
    this.open();
}

Hint.prototype._onElementMouseLeaveEvent = function(e) {
    // таймаут позволяет выйти из общего потока и его можно отменить
    // 0 сек т.к. события mouseleave, mouseenter идут друг за другом
    clearTimeout(this._leaveTimeout);
    this._leaveTimeout = setTimeout(() => {
        this.close();
    }, 0);
}

/**
 * Повесить обработчики событий скролла на родительские элементы
 * нужно для обновления позиции хинта
 */
Hint.prototype._hookAllParentScrolls = function() {
    this._unhookAllParentScrolls();
    this._parentsWithScrollEventAttached = [document];

    let $parent = this.$target;
    while ($parent = $parent.offsetParent) {
        this._parentsWithScrollEventAttached.push($parent);
    }

    this._parentsWithScrollEventAttached.forEach($parent => $parent.addEventListener('scroll', this._updatePositionBind));
}

/**
 * Снять обработчики
 */
Hint.prototype._unhookAllParentScrolls = function() {
    this._parentsWithScrollEventAttached.forEach($parent => $parent.removeEventListener('scroll', this._updatePositionBind));
}

const elementClassMap = new WeakMap();
Hint.init = function(options) {
    document.addEventListener('mouseover', e => {
        const $hint = e.target.closest('[data-hint-content]');
        if (!$hint) {
            return;
        }

        if (!$hint.dataset.hintContent.trim().length) {
            return;
        }

        if (elementClassMap.has($hint)) {
            return;
        }

        if (typeof options == 'function') {
            options = options($hint);
        }

        options = options || {};

        elementClassMap.set($hint, new Hint($hint, options));
    });
}

Hint.prototype.closeAll = function() {
    document.querySelectorAll('.Hint.is-active').forEach($hint => $hint.classList.remove('is-active'));
}


export default Hint;
